"use strict";

var _classCallCheck = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/Users/thomashopf/Documents/repositories/marks_lab/EVcouplings-server-frontend2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var AlignmentSorter_1 = require("../common/AlignmentSorter");
var AceEditorComponent_1 = require("./AceEditorComponent");
var AceMultipleSequenceAlignmentComponent = /*#__PURE__*/function (_AceEditorComponent_) {
  _inherits(AceMultipleSequenceAlignmentComponent, _AceEditorComponent_);
  function AceMultipleSequenceAlignmentComponent() {
    _classCallCheck(this, AceMultipleSequenceAlignmentComponent);
    return _possibleConstructorReturn(this, _getPrototypeOf(AceMultipleSequenceAlignmentComponent).apply(this, arguments));
  }
  _createClass(AceMultipleSequenceAlignmentComponent, [{
    key: "getText",
    value: function getText() {
      return this.props.alignment.getSequences(this.props.sortBy).map(function (x) {
        return x.sequence;
      }).join("\n");
    }
  }, {
    key: "getEditorMode",
    value: function getEditorMode() {
      return this.props.alignment.getAceEditorMode();
    }
  }]);
  return AceMultipleSequenceAlignmentComponent;
}(AceEditorComponent_1.AceEditorComponent);
exports.AceMultipleSequenceAlignmentComponent = AceMultipleSequenceAlignmentComponent;
AceMultipleSequenceAlignmentComponent.defaultProps = {
  sortBy: AlignmentSorter_1.SequenceSorter.INPUT,
  fontSize: 14
};